import React from 'react';
import { isoToMonthDateYear } from '../../../helpers/helpers';
import AddAds from '../CampaignHome/AddAds/AddAds';
import { Button } from '@progress/kendo-react-buttons';
import Footer from '../../../Components/Footer';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import AdsMap from './AdsMap/AdsMap';
import "./CampaignAdsDetails.css"
import AdsCard from './AdsCard.js/AdsCard';
import StatusChip from '../../../Components/StatusChip';
import { Field, FieldWrapper, Form, FormElement } from '@progress/kendo-react-form';
import { FormDateRangePicker, FormInput } from '../../../Utils/form-components';
import { FetchCampaigns, saveCampaign } from '../../../Api/CampaignApi';
import { myInputValidator } from '../../../Utils/validators';

const CampaignAdsDetails = ({ detail, ...props }) => {

    const [addAdsVisible, setAddAdsVisible] = React.useState(false);
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [readOnly, setReadOnly] = React.useState(true);
    const [editItem, setEditItem] = React.useState();
    const [resetForm, setResetForm] = React.useState(false);


    const toggleAddAdsDialog = () => {
        setAddAdsVisible((prevState) => !prevState); // Properly toggle the state
    };

    const handleSelectTab = e => {
        setSelectedTab(e.selectedTab);
    };

    const handleSubmit = async dataItem => {
        let saveData = {
            "Id": dataItem.id || 0,
            "Title": dataItem.title,
            "startCampaignDate": dataItem.campaignDate?.start || new Date().toISOString,
            "endCampaignDate": dataItem.campaignDate?.end || dataItem.campaignDate?.start || new Date().toISOString,
            "status": dataItem.status,
            "redirectURL": dataItem.redirectURL,
            "description": dataItem.description,

            "adsClientId": JSON.parse(localStorage.getItem("userId"))
        }

        try {
            await saveCampaign(saveData).then(() => {
                props.setAlertMessage("Saved Campaign")
                props.onTriggerAlert('success')

                props.toggleRefresh()
                setReadOnly(true)
                fetchItem(true)
            });
        } catch (error) {

            props.setAlertMessage(error)
            props.onTriggerAlert('error')
            console.log(error);
        }

    }

    const fetchItem = React.useCallback(async (isResetForm) => {
        try {
            const res = await FetchCampaigns({
                SearchList: [{ ClientId: props.clientId, id: detail.id }]
            });

            // Transform data to include campaignDate
            const transformedCampaignList = res.map(campaign => ({
                ...campaign,
                campaignDate: {
                    start: new Date(campaign.startCampaignDate),
                    end: new Date(campaign.endCampaignDate)
                }
            }));

            setEditItem(transformedCampaignList[0]);

            // Reset form
            if (isResetForm) resetFormState();
        } catch (error) {
            console.error("Error fetching campaign ads:", error);
        }
    }, [detail.id, props.clientId]);

    const resetFormState = () => {
        setResetForm(true);
        setTimeout(() => setResetForm(false), 0);
        // setResetForm(Date.now()); // Force re-render
    };

    React.useEffect(() => {
        fetchItem();
    }, [fetchItem]);

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: "column", width: "100%", gap: '40px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: "60px", flexGrow: 1 }}>
                {/* Top Ad Details + Add Advertisement Button */}
                <div style={{ display: 'flex', flexDirection: "row", justifyContent: "space-between" }}>
                    {editItem && <div style={{ width: "100%" }}>
                        <div>
                            <Form
                                // key={editItem?.id || resetForm} // Ensure a new form instance when editItem updates
                                key={`${editItem?.id}-${resetForm}`} // Unique key to trigger rerender

                                initialValues={editItem}
                                onSubmit={handleSubmit}
                                render={formRenderProps => <FormElement >
                                    <div className="k-form-buttons" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ display: "flex", gap: '22px' }}>
                                            <div>
                                                <h2 style={{ margin: "0" }}>{editItem.title}</h2>

                                                <div style={{ display: "flex", gap: "42px", }}>
                                                    <div style={{ color: 'gray', fontSize: "14px" }}>
                                                        <span style={{ marginTop: "4px" }}>{isoToMonthDateYear(editItem.startCampaignDate)}</span> -
                                                        <span style={{ marginTop: "4px" }}> {isoToMonthDateYear(editItem.endCampaignDate)}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div style={{ alignContent: "center" }}>
                                                <StatusChip
                                                    value={editItem.status}
                                                    color={{
                                                        "Pending": "yellow",
                                                        "Finished": "orange",
                                                        "Active": "green"
                                                    }[editItem.status]} />
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            {readOnly ? <>
                                                <Button themeColor={'primary'} onClick={() => setReadOnly(!readOnly)}>
                                                    Edit Campaign
                                                </Button>
                                            </> : <>
                                                <Button themeColor={'secondary'} onClick={() => setReadOnly('false')}>
                                                    Cancel
                                                </Button>
                                                <Button
                                                    themeColor={"primary"}
                                                    type={"submit"}
                                                    disabled={!formRenderProps.allowSubmit}
                                                >
                                                    Submit
                                                </Button>
                                            </>}
                                        </div>
                                    </div>



                                    {readOnly ? <div >
                                        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '18px' }}>
                                            <div style={{ marginBottom: "32px" }}>
                                                {editItem.description}
                                            </div>

                                            <div style={{ display: "flex", width: "100%", gap: '42px', marginTop: "4px" }}>
                                                <div>
                                                    <div style={{ color: "gray", margin: 0, fontSize: "12px" }}>Redirect URL</div>
                                                    <a
                                                        style={{ fontWeight: "600" }}
                                                        href={editItem.redirectURL?.startsWith("http") ? editItem.redirectURL : `https://${editItem.redirectURL}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {editItem.redirectURL}
                                                    </a>
                                                </div>
                                                <div style={{ textAlign: "center" }}>
                                                    <div style={{ color: "gray", margin: 0, fontSize: "12px" }}>Campaign Views</div>
                                                    <span style={{ fontWeight: "400" }} >{editItem.campaignViews || 0}</span>
                                                </div>
                                                <div style={{ textAlign: "center" }}>
                                                    <div style={{ color: "gray", margin: 0, fontSize: "12px" }}>Campaign Clicks</div>
                                                    <span style={{ fontWeight: "400" }} >{editItem.campaignClicks || 0}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : <fieldset className={'k-form-fieldset'}>
                                        <div className='field-wrapper'>
                                            <FieldWrapper>
                                                <Field id={'title'} name={'title'} label={'Title'} component={FormInput} />
                                            </FieldWrapper>
                                            <FieldWrapper>
                                                <Field name={"redirectURL"} component={FormInput} label={"Redirect Url"} />
                                            </FieldWrapper>
                                        </div>
                                        <div className='field-wrapper'>
                                            <FieldWrapper>
                                                <Field id={'campaignDate'} name={'campaignDate'} label={'Campaign Date'} component={FormDateRangePicker} validator={myInputValidator} />
                                            </FieldWrapper>
                                        </div>
                                        <div className='field-wrapper'>
                                            <FieldWrapper>
                                                <Field style={{ width: '582px', height: "120px" }} name={"description"} component={FormInput} label={"Description"} />
                                            </FieldWrapper>
                                        </div>


                                    </fieldset>
                                    }
                                </FormElement>} />
                        </div>




                        {/* Add Advertisement */}
                        <div style={{ marginTop: "44px" }}>
                            <div style={{ display: 'flex', justifyContent: "space-between" }}>
                                <h2>Advertisements</h2>

                                <div className="k-form-buttons">
                                    <Button
                                        themeColor={'primary'}
                                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                        onClick={toggleAddAdsDialog}
                                    >
                                        Add Advertisement
                                    </Button>
                                </div>
                            </div>

                            <AdsCard key={detail.id} campaign={detail} />
                        </div>
                    </div>}

                </div>
                {/* Tabstrip */}
                <div className='ads-details' style={{ width: "100%" }}>
                    <TabStrip key={editItem?.id} selected={selectedTab} onSelect={handleSelectTab}>
                        <TabStripTab title="Sites">
                            <AdsMap campaignId={detail.id} {...props} />
                        </TabStripTab>
                        {/* <TabStripTab title="Details" disabled>
                            <div>
                                The City of New York, often called New York City or simply New York, is the most populous city in the United States. With an estimated 2015 population of 8,550,405 distributed over a land area of just 305 square miles (790 km2), New York City is also the most densely populated major city in the United States. Located at the southern tip of the state of New York, the city is the center of the New York metropolitan area, one of the most populous urban agglomerations in the world.
                            </div>
                        </TabStripTab>
                        <TabStripTab title="Options" disabled>
                        </TabStripTab> */}
                    </TabStrip>
                </div>
            </div>

            <Footer item={detail} />

            {addAdsVisible && <AddAds campaignId={detail.id} closeDialog={() => setAddAdsVisible(false)}  {...props} />}
        </div >
    );
}

export default CampaignAdsDetails;
